import React from 'react';

const SupportTicketIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3353 1.63646V0H20V6.67796H18.3635V2.79016L10.3204 10.8333L9.16667 9.67963L17.2098 1.63646H13.3353ZM1.66667 18.3333H16.678V8.34383H18.3446V18.3333C18.3446 19.25 17.5946 20 16.678 20H1.66667C0.741667 20 0 19.25 0 18.3333V3.33899C0 2.42232 0.741667 1.67232 1.66667 1.67232H11.6914V3.33899H1.66667V18.3333Z"
      fill="#FA6400"
    />
  </svg>
);

export default SupportTicketIcon;
